import api from "@/aygulyazilim/libs/axios";
import navMenuItems from "@/navigation/vertical";
import dayjs from "dayjs";

import CryptoJS from "crypto-js";
import { defineStore } from "pinia";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { useAuthStore } from "./useAuth";

const secretKeyBase = import.meta.env.VITE_APP_secretKey;

export const useHelpersStore = defineStore("helpers", {
  state: () => {
    return {
      message: null,
      errors: {},
      config: {
        firma_adi: "",
      },
      ilList: [],
      items: [],
      activeOptions: [
        { label: "Hepsi", value: -1 },
        { label: "Aktif", value: 1 },
        { label: "Pasif", value: 0 },
      ],
      sinifUcret: [
        { label: "Sabit Fiyat", value: 1 },
        { label: "Aylık Abonelik", value: 2 },
        { label: "Özel Ders", value: 3 },
      ],
      cariTipList: [
        { label: "Alış", value: 1 },
        { label: "Satış", value: 2 },
        { label: "Alış+Satış", value: 3 },
      ],
      envanterStatusList: [
        { label: "Yeni" },
        { label: "Aktif" },
        { label: "Zimmet" },
        { label: "Tamirde" },
        { label: "Hurda" },
        { label: "Depoda" },
        { label: "Diğer" },
      ],
      stokIslemTipGirisList: [
        { label: "Serbest Stok Girişi" },
        { label: "Alım İrsaliye Girişi" },
        { label: "Satış İade İrsaliyesi" },
        { label: "Üretimden Giriş" },
        { label: "Konsinye Alım İrsaliyesi" },
      ],
      stokIslemTipCikisList: [
        { label: "Serbest Stok Çıkışı" },
        { label: "İrsaliyeli Çıkış" },
        { label: "Alım İade İrsaliyesi" },
        { label: "Üretime Çıkış" },
        { label: "Konsinye İade İrsaliyesi" },
        { label: "Satış" },
        // { label: "Depo Sayım Fişi" },
      ],
    };
  },
  getters: {
    resolveActiveVariant: (state) => {
      return (active) => {
        if (active === 1) return { color: "primary", text: "Aktif" };
        if (active === true) return { color: "primary", text: "Aktif" };
        else return { color: "error", text: "Pasif" };
      };
    },
    resolveEvetVariant: (state) => {
      return (active) => {
        if (active === 1) return { color: "primary", text: "Evet" };
        if (active === true) return { color: "primary", text: "Evet" };
        else return { color: "error", text: "Hayır" };
      };
    },
    getSinifUcret: (state) => {
      return (value) => {
        if (value == -1) return "Ödeme";
        const item = state.sinifUcret.find((item) => item.value == value);
        return item ? item.label : "";
      };
    },
    formatTarih() {
      return (date) => {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        return `${day}.${month}.${date.getFullYear()}`;
      };
    },
    getDeger(state) {
      return (value, tip = 0) => {
        const item = state.items.find((item) => item.name === value);
        if (tip == 1) return item?.deger == 1 ? true : false;
        return item ? item.deger : "";
      };
    },
    formatTime() {
      return (date) => {
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
          return "";
        }
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        return `${hours}:${minutes}`;
      };
    },
    formatTimeRange() {
      return (dates) => {
        if (!Array.isArray(dates) || dates.length < 2) return "";

        const start = this.formatTime(dates[0]);
        const end = this.formatTime(dates[1]);

        return start && end ? `[${start} - ${end}]` : "";
      };
    },
  },
  actions: {
    navMenu() {
      const tempData = [];
      for (let index = 0; index < navMenuItems.length; index++) {
        if (navMenuItems[index].yetki !== undefined) {
          if (this.yetkiKontrol(navMenuItems[index].yetki)) {
            if (navMenuItems[index].children !== undefined) {
              const child = [];
              for (let i = 0; i < navMenuItems[index].children.length; i++) {
                if (this.yetkiKontrol(navMenuItems[index].children[i].yetki)) {
                  // navMenuItems[index].children.splice(i, 0);
                  child.push(navMenuItems[index].children[i]);
                }
              }
              navMenuItems[index].children = child;
            }
            tempData.push(navMenuItems[index]);
          }
        } else {
          tempData.push(navMenuItems[index]);
        }
      }

      return tempData;
    },
    yetkiKontrol({ k = [], a = false, p = false, e = false } = {}) {
      const authStore = useAuthStore();
      const user = authStore?.user;
      if (!user) return false;
      if (k.length === 0 && a === false && p === false && e === false)
        return true;
      if (e && user.egitmen) return true;
      if (p && user.programci) return true;
      if (a && (user.programci || user.admin)) return true;
      for (let i = 0; i < k.length; i++) {
        if (user.programci || user.admin) return true;
        const s = user.yetkiler?.filter((x) => x.kod === k[i]);
        if (s && s.length > 0) return true;
      }

      return false;
    },
    async fetchConfig() {
      try {
        this.items = [];
        const res = await api.get("config");
        if (res != undefined) {
          this.items = res?.data;
          for (let i = 0; i < this.items.length; i++) {
            this.config[this.items[i].name] = this.getDeger(this.items[i].name);
          }
        }
      } catch (error) {
        this.toast("error", "Ayarlar yüklenirken hata oluştu.");
      }
    },
    async toast(status, message) {
      switch (status) {
        case "success":
          toast.success(message, {
            theme: "auto",
            autoClose: 5000,
            dangerouslyHTMLString: true,
          });
          break;
        case "error":
          toast.error(message, {
            theme: "auto",
            autoClose: 5000,
            dangerouslyHTMLString: true,
          });
          break;
        case "danger":
        case "warn":
        case "warning":
          toast.warning(message, {
            theme: "auto",
            autoClose: 5000,
            dangerouslyHTMLString: true,
          });
          break;
        case "info":
          toast.info(message, {
            theme: "auto",
            autoClose: 5000,
            dangerouslyHTMLString: true,
          });
          break;
        default:
          toast(message, {
            theme: "auto",
            type: "default",
            autoClose: 5000,
            dangerouslyHTMLString: true,
          });
      }
    },
    async listIl() {
      const res = await api.get("il");
      if (res != undefined) {
        this.ilList = res?.data || [];
      }
    },
    async copyHafiza(mytext) {
      try {
        await navigator.clipboard.writeText(mytext);
        this.toast("success", "Panoya kopyalandı!");
      } catch ($e) {
        this.toast("error", "Hata oluştu");
      }
    },
    /**
     * Günlük anahtarla AES şifrelemesi yapar.
     * @param {Object} data - Şifrelenecek veri
     * @returns {string} Şifrelenmiş veri
     */
    encryptData(data) {
      const tarih = dayjs().format("YYYYMMDD");
      const secretKey = `${secretKeyBase}${tarih}`;
      const dataString = JSON.stringify(data);

      // Veriyi şifreleyin
      const encryptedData = CryptoJS.AES.encrypt(
        dataString,
        secretKey
      ).toString();

      return encryptedData;
    },
  },
});
